<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 16:39:35
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-02-21 14:29:05
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/brandProduct/components/editProductType.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-dialog v-model="dialogFormVisible" :title="title" width="500px" @close="close">
    <el-form ref="formRef" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { addProductAttribute, editProductAttribute } from '@/api/brand'

  export default defineComponent({
    name: 'EditSort',
    props: {
      enterpriseCode: {
        type: String,
        default: '',
      },
      exhibitorCode: {
        type: String,
        default: '',
      },
    },
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        formRef: null,
        treeRef: null,
        checkMenu: [],
        form: {
          name: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入名称' }],
        },
        title: '',
        dialogFormVisible: false,
        list: [],
        flag: '',
        nowSort: '',
      })

      const showEdit = async (row) => {
        if (row) {
          state.form = Object.assign({}, row)
          state.title = '编辑类型'
        } else {
          state.title = '新建类型'
        }

        state.dialogFormVisible = true
      }
      const close = () => {
        state['formRef'].resetFields()
        state.form = {
          name: '',
        }
        state.dialogFormVisible = false
      }

      const save = () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            try {
              state.form.type = 'TYPE'
              state.form.enterpriseCode = props.enterpriseCode
              state.form.enterpriseType = props.enterpriseCode ? 'ENTERPRISE' : 'EXHIBITOR'
              state.form.exhibitorCode = props.exhibitorCode
              state.form.delFlag = false
              if (state.form.id) {
                await editProductAttribute(state.form)
              } else {
                await addProductAttribute(state.form)
              }
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
              emit('fetch-data')
              close()
            } catch (e) {}
          }
        })
      }
      return {
        ...toRefs(state),
        showEdit,
        close,
        save,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }
</style>
